<template>
    <div ref="dropdownWrapper">
        <div v-if="getActions().length > 0" class="relative flex justify-end">
            <button class="focus:outline-none" @click="toggleDropdown">
                <img src="../../../assets/images/vertical-dot-icon.png" alt="Up Down Arrow" class="w-[30px] h-[30px]" />
            </button>
            <ul v-if="isOpen" :class="[
                'absolute right-[30px] z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-roboto py-[5px] overflow-hidden',
                openUpwards ? '-bottom-[80px]' : 'top-[10px]'
            ]">
                <li v-for="option in getActions()" :key="option" @click="select(option)"
                    class="px-2 py-[5px] mx-[10px] my-[5px] rounded-md hover:bg-customYellow-100 hover:text-white cursor-pointer text-left">
                    {{ option }}
                </li>
            </ul>
        </div>
        <div v-else class="relative flex mr-4 justify-end">
            -
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionDropdown",

    props: {
        item: Object,
        rowIndex: Number,
        totalRows: Number
    },

    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    unmounted() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    computed: {
        openUpwards() {
            return this.rowIndex >= this.totalRows - 5
        }
    },

    methods: {

        getActions() {
            let res = []
            if (this.user?.user?.user_id == this.item.parent_id) {
                res.push("Edit")
                res.push("Resend Invite")
                // if (window.innerWidth >= 1320) {
                //     res.push("View Affiliate Tree")
                // }

                if (this.item.active != '1') {
                    res.push("Active")
                }
                else {
                    res.push("Inactive")
                }

            }
            let affiliateType = this.user.user.affiliate.affiliate_type
            if (affiliateType == 'master') {

                if (this.item.affiliate_type_slug == 'normal') {
                    res.push("Mark as Employee")
                }
                else if (this.item.affiliate_type_slug == 'employee') {
                    res.push("Mark as Standard")
                }
            }

            return res
        },

        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },

        select(option) {
            this.$emit("select", option); // parent ko notify karega
            this.isOpen = false;
        },

        handleClickOutside(e) {
            if (this.$refs.dropdownWrapper && !this.$refs.dropdownWrapper.contains(e.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>
